import { INIT_FEEDBACK } from './constants';

export default function initFeedback() {
  return {
    type: INIT_FEEDBACK,
  };
}
